import { Directive, HostListener, Input, Optional } from '@angular/core';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';

@Directive({
  selector: '[cwtCloseDrawer]',
  standalone: true,
})
export class CloseDrawerDirective {

  @Input('cwtCloseDrawer') data: any;

  constructor(@Optional() private drawer: NzDrawerRef) { }

  @HostListener('click', ['$event'])
  public close(event: Event) {
    if (!this.drawer) return;
    event?.stopPropagation();
    event?.preventDefault();
    this.drawer.close(this.data);
  }
}
